
import { useState } from 'react';
import Logo from '../../../components/base/Logo';

const YandexMapsPage = () => {
  // Form handling state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-16">
            <Logo />

            {/* Navigation content */}
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Главная</a>
              <a href="/blog" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Блог</a>
              <a href="#services" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Услуги</a>
              <a href="#contact" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Контакты</a>
            </nav>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-50 to-orange-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Продвижение в Яндекс Картах
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Выводим ваш бизнес в ТОП локальной выдачи Яндекс Карт. Накрутка поведенческих факторов и гарантия результата.
              </p>
              <div className="bg-red-100 border border-red-200 rounded-lg p-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-star-fill text-red-600 mr-2"></i>
                  <span className="font-semibold text-red-800">Собственный сервис накрутки поведенческих факторов</span>
                </div>
                <p className="text-red-700 mt-2">Гарантируем попадание в ТОП-1 локальной выдачи</p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                  Попасть в ТОП-1
                </button>
                <button className="border border-red-600 text-red-600 px-8 py-3 rounded-lg hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer">
                  Анализ позиций
                </button>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Yandex%20Maps%20local%20business%20optimization%20specialist%20working%20on%20mobile%20device%20showing%20map%20interface%20with%20business%20listings%2C%20modern%20office%20setup%20with%20red%20and%20orange%20color%20scheme%2C%20local%20SEO%20and%20maps%20marketing%20atmosphere&width=600&height=400&seq=yandex-maps-hero&orientation=landscape"
                alt="Продвижение в Яндекс Картах"
                className="rounded-lg shadow-xl object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Что входит в продвижение
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Комплексная работа для максимального результата в Яндекс Картах
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-map-pin-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Оптимизация карточки</h3>
              <p className="text-gray-600 mb-4">
                Полная настройка и оптимизация карточки организации
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Заполнение всех полей</li>
                <li>• Добавление фотографий</li>
                <li>• Описание услуг</li>
                <li>• Контактная информация</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-mouse-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Накрутка поведенческих</h3>
              <p className="text-gray-600 mb-4">
                Собственный сервис накрутки поведенческих факторов
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Переходы на сайт</li>
                <li>• Звонки с карт</li>
                <li>• Просмотры фотографий</li>
                <li>• Построение маршрутов</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-star-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Отзывы и рейтинг</h3>
              <p className="text-gray-600 mb-4">
                Работа с отзывами для повышения рейтинга
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Получение отзывов</li>
                <li>• Ответы на отзывы</li>
                <li>• Повышение рейтинга</li>
                <li>• Работа с негативом</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-search-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Локальное SEO</h3>
              <p className="text-gray-600 mb-4">
                Оптимизация для локальных поисковых запросов
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Локальные ключевые слова</li>
                <li>• Геозависимые запросы</li>
                <li>• Микроразметка</li>
                <li>• Локальные ссылки</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-camera-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Фото и видео</h3>
              <p className="text-gray-600 mb-4">
                Создание качественного визуального контента
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Фотосъемка офиса</li>
                <li>• Товары и услуги</li>
                <li>• Команда и процессы</li>
                <li>• Видео-презентации</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-bar-chart-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Аналитика</h3>
              <p className="text-gray-600 mb-4">
                Отслеживание результатов и корректировка стратегии
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Позиции в картах</li>
                <li>• Количество показов</li>
                <li>• Переходы и звонки</li>
                <li>• Конверсия заявок</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-20 bg-red-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Гарантия результата
            </h2>
            <p className="text-xl text-gray-600">
              Мы гарантируем попадание в ТОП-1 локальной выдачи
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-6">
                1
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">ТОП-1 за 30 дней</h3>
              <p className="text-gray-600">
                Гарантируем попадание в первую позицию локальной выдачи в течение месяца
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl mx-auto mb-6">
                <i className="ri-shield-check-line"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Возврат средств</h3>
              <p className="text-gray-600">
                Если не достигнем результата - вернем 100% стоимости услуг
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-3xl mx-auto mb-6">
                <i className="ri-customer-service-line"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Поддержка 24/7</h3>
              <p className="text-gray-600">
                Персональный менеджер и техническая поддержка в любое время
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Тарифы продвижения в Яндекс Картах
            </h2>
            <p className="text-xl text-gray-600">
              Выберите подходящий пакет услуг
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white border border-gray-200 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Базовый</h3>
              <div className="text-4xl font-bold text-red-600 mb-6">
                15 000 ₽
                <span className="text-lg text-gray-500 font-normal">/мес</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Оптимизация карточки</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Базовая накрутка</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Работа с отзывами</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Ежемесячные отчеты</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>1 регион</span>
                </li>
              </ul>
              <button className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>

            <div className="bg-red-50 border-2 border-red-600 rounded-xl p-8 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                  Популярный
                </span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Профессиональный</h3>
              <div className="text-4xl font-bold text-red-600 mb-6">
                30 000 ₽
                <span className="text-lg text-gray-500 font-normal">/мес</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Все из базового</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Усиленная накрутка</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Фото и видео контент</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Локальное SEO</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>До 3 регионов</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Гарантия ТОП-1</span>
                </li>
              </ul>
              <button className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Корпоративный</h3>
              <div className="text-4xl font-bold text-red-600 mb-6">
                60 000 ₽
                <span className="text-lg text-gray-500 font-normal">/мес</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Все из профессионального</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Максимальная накрутка</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Профессиональная съемка</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Комплексное продвижение</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Неограниченно регионов</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Персональный менеджер</span>
                </li>
              </ul>
              <button className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Попасть в ТОП-1 Яндекс Карт
            </h2>
            <p className="text-xl text-gray-600">
              Получите бесплатный анализ позиций и персональную стратегию
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Ваше имя *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Введите ваше имя"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Телефон *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="+7 (999) 123-45-67"
                  />
                </div>
                <div>
                  <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-2">
                    Название организации *
                  </label>
                  <input
                    type="text"
                    id="website"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="ООО Ваша компания"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Регион и сфера деятельности
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm resize-none"
                  placeholder="Укажите ваш регион и сферу деятельности..."
                />
                <div className="text-right text-sm text-gray-500 mt-1">
                  {formData.message.length}/500
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-red-600 text-white py-4 px-8 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
              >
                Получить анализ позиций
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <Logo />
              <p className="text-gray-400 mt-4">
                Профессиональное SEO продвижение сайтов
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Услуги</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/services/yandex-maps" className="hover:text-white transition-colors cursor-pointer">Яндекс Карты</a></li>
                <li><a href="/services/google-maps" className="hover:text-white transition-colors cursor-pointer">Google Карты</a></li>
                <li><a href="/services/yandex-seo" className="hover:text-white transition-colors cursor-pointer">Продвижение в Яндекс</a></li>
                <li><a href="/services/google-seo" className="hover:text-white transition-colors cursor-pointer">Продвижение в Google</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Контакты</h4>
              <ul className="space-y-2 text-gray-400">
                <li>+7 (950) 360-35-20</li>
                <li>info@seo-agency.ru</li>
                <li>Москва, ул. Примерная, 123</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Социальные сети</h4>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-telegram-line text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-vk-line text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 SEO Продвижение. Все права защищены. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-1">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default YandexMapsPage;
